export function required_unless(parameters, fields) {
  const [key, ...values] = parameters;
  const other = fields[key] || key;
  return {
    other: other,
    values: values.join(', ')
  };
}
